import React, {Component,Fragment} from "react";
/*
    For Redux, need to import connect and action
    Redux connect is to access Redux
    Redux action to update the state of the form field
*/
import { connect } from "react-redux";
import { updateForm, setStep } from "../../../store/actions/FormAction";
/*
    Importing React Scroll for animating scrolling down to elements
*/
import { animateScroll as scroll } from 'react-scroll';
/*
    Importing LoanSlider that is a component that loanamt in Redux
*/
import LoanSlider from "../../partials/LoanSlider";
/*
    Importing StateSelector for autocomplete States input box
*/
import StateSelector from "../../partials/StateSelector";
/*
    Importing AlertDialogSlide for sliding Modal Window
*/
import AlertDialogSlide from "../../partials/AlertDialogSlide";
/*
    Importing NextStepButton that is a component that updates the page in Redux
*/
import NextStepButton from "../../partials/NextStepButton";
/*
    This page is using a template WelcomeLayout - no progressbar and no nav
*/
import WelcomeLayout from '../../../containers/WelcomeLayout.js';
/*
    Custom styling of the range slider (Welcome.css)
*/
import './gsap.css';
import './Slider.css';
import './Welcome.css';

/*
    Using Validation functions from utils folder
*/
import Validation from '../../../utils/Validation';
const validation = new Validation();

/*
    Welcome view that displays the Welcome page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
    SVGs need to have the xml attributes removed
*/
class StartApplication extends Component {
  constructor(props){
    super(props);

    this.emailcheck = false;
    this.handleEmailChange = this.handleEmailChange.bind(this);

  }

  componentDidMount() {

    this.props.updateForm("pagename", "Apply Now");
    this.props.setStep(0);

    // email from state
    if (this.props.eml.length > 1) {
      this.emailcheck = true;
      document.querySelector("label[for='eml']").classList.add("active");
    } 
    if (this.props.statechecked) {
      document.querySelector("label[for='st']").classList.add("active");
      if (this.props.stateserved){
        document.getElementById("loanslider").classList.remove("hidden");
      }
    }

    const AUTOFILLED = 'is-autofilled';
    const onAutoFillStart = (el) => el.classList.add(AUTOFILLED);
    const onAutoFillCancel = (el) => el.classList.remove(AUTOFILLED);
    const onAnimationStart = ({ target, animationName }) => {
        switch (animationName) {
            case 'onAutoFillStart':
                //console.log("onAutoFillCancel");
                if (target.id === "eml"){
                  let email = target.value;
                  this.props.updateForm("eml", email);
                  if (validation.validateEmail(email)) {
                    this.emailcheck = true;
                    this.props.updateForm("emailchecked", true);
                    document.querySelector("label[for='eml']").classList.add("active");
                  }
                } else if (target.id === "st"){
                  this.props.updateForm("st", target.value);
                  //need to populate all the other fields like it was selected
                }
                return onAutoFillStart(target);
            case 'onAutoFillCancel':
                //console.log("onAutoFillCancel");
                return onAutoFillCancel(target);
            default:
                break;
        }
    }
    document.querySelector('input').addEventListener('animationstart', onAnimationStart, false);
  }

  handleEmailChange(e) {
    let email = e.target.value;
    this.props.updateForm("eml", email);

    let emltip = document.getElementById("emltip");
    const emaillabel = document.querySelector("label[for='eml']");

    if (validation.validateEmail(email)) {
      this.emailcheck = true;
      this.props.updateForm("emailchecked", true);
      emltip.innerHTML = "";
      emltip.classList.add("hidden");
      emaillabel.classList.add("active");
    } else {
      this.emailcheck = false;
      this.props.updateForm("emailchecked", false);
      emaillabel.classList.remove("active");
    }

    if (this.emailcheck && this.props.statechecked){

      if (window.pageYOffset < 250)
        scroll.scrollTo(250, {duration: 800});
      let sliderdiv = document.getElementById("loanslider");
      if (this.props.stateserved){
        sliderdiv.classList.remove("hidden");
        setTimeout(()=>{document.querySelector('.rangeslider__handle').focus()},10);
      } else {
        sliderdiv.classList.add("hidden");
      }
      setTimeout(this.props.updateForm,10,"startapp",true);
    } else {
      this.props.updateForm("startapp", false);
    }
  }

  handleEmailBlur(e) {
    let email = e.target.value;
    let emltip = document.getElementById("emltip");

    if (email.length < 1) {
      emltip.innerHTML = "Please enter an email address.";
      emltip.classList.remove("hidden");
    } else if (!validation.validateEmail(email)) {
      emltip.innerHTML = email + " is not a valid email.";
      emltip.classList.remove("hidden");
    }
  }

  render() {
      const nextLink = "/createpassword";
      const nextStep = 0;
      const btnText = "Start Application";
      const btnClasses = "btn padtop first-step";

      return (
        <WelcomeLayout>
            <div className="container" id="step-1">
                <div className="text-center topcopy">
                  <h1 style={{marginTop:0}}>Let&#39;s get started</h1>
                  <h5>Please complete the form so we can get you started on your application.</h5>
                </div>
                <hr />
                <form className="flowform">
                  <input type="hidden" value="needed for disabling autocomplete" />
                  <div className="form-group">
                      <label htmlFor="eml" >
                          Email
                          <div className="errortip hidden" id="emltip">
                              Please provide a valid email address.
                          </div>
                          <input type="email" name="eml" id="eml" autoComplete="eml" className="form-control" tabIndex="1" value={this.props.eml} onChange={this.handleEmailChange} onBlur={this.handleEmailBlur} /> <div className="nothuman"><input type="email" name="email" /></div>
                      </label>
                  </div>
                  <div className="form-group">
                      <label htmlFor="st">
                          Your State of Residence
                          <StateSelector />
                      </label>
                  </div>
                  <div id="loanslider" className="hidden form-group" >
                    <LoanSlider />
                  </div>
                  <div className="text-center padtop">
                    <p>
                      By providing your email address, you consent to receive marketing and other communications from MoneyKey in accordance with our <AlertDialogSlide linkText="Privacy Policy" tip="privacypolicy"/>.
                    </p>

                    <NextStepButton next={nextLink} btnText={btnText} btnClasses={btnClasses} step={nextStep} disableNext={!this.props.startapp} />

                    <p className="padtop40"><a className="padtop" href="https://qa-mkt.moneykey.com/">Take me back to Home</a></p>
                  </div>
                </form>
                <hr />
                <div className="trustpilotwidget padtop">
                  <span><strong className="ratingtext">Excellent &nbsp;</strong></span>
                  <img src="/images/reviews/5_stars.png" className="trustpilotstars" alt="trustpilot-top-review-rating"/>
                  <span className="hidden-xs">&nbsp; based on <strong>1,341</strong> reviews &nbsp;</span>
                  <img src="/images/reviews/trustpilot_logo-dark.png" className="trustpilotlogo" alt="trustpilotlogo"/>
                </div>


            </div>
          </WelcomeLayout>
        );
    }
}

const mapStateToProps = (state) => ({
    askedforamt: state.FormReducer.askedforamt,
    eml: state.FormReducer.eml,
    emailchecked: state.FormReducer.emailchecked,
    st: state.FormReducer.st,
    statechecked: state.FormReducer.statechecked,
    stateserved: state.FormReducer.stateserved,
    startapp: state.FormReducer.startapp,
    loggedin: state.FormReducer.loggedin
})

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setStep: (step) => dispatch(setStep(step))
})

export default connect(mapStateToProps, mapDispatchToProps)(StartApplication);



// WEBPACK FOOTER //
// ./src/components/views/StartApplication/index.js